module.exports = __webpack_public_path__ + "static/media/WAN.c58949f8.svg";